window.ReviewDetails = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            buttons: {
                cancelButton: '#review-details-form-cancel',
                continueButton: '#review-details-form-continue'
            },
            checkbox:{
                checkBox1: '#review-details-form-confirmation-checkbox'
            },
            messages:{
                invalidFormMessage: '#review-details-form-invalid-form-message'
            }
        },
        css: {
            invalidCheckboxError: 'vds-checkbox--invalid',
            checkBoxGroup:'.vds-checkbox--contained'
        },
        urls: {
            manageMembers: '/my-health-insurance/manage-my-plan/manage-members',
            resetSession: '/api/sitecore/AddMembers/ResetSession',
            errorPageUrl: '/error/error-page',
            importantInformation: '/my-health-insurance/manage-my-plan/add-members/important-info',
            cacheReviewPageDetails: '/api/sitecore/AddMembers/CacheReviewPageDetails'
        },
        func: {
            init: function () {
                self.func.bindings();
                self.func.initializeValidationMessage();
            },
            bindings: function () {
                $(self.elements.buttons.continueButton).on('click', self.func.handleReviewDetailsRequest);
                $(self.elements.buttons.cancelButton).on('click', self.func.cancelReviewDetailsRequest);
                $(self.elements.checkbox.checkBox1).on('change', self.func.clearValidationMessage);
            },
            initializeValidationMessage: function () {
                $(self.elements.messages.invalidFormMessage).hide();
            },
            handleReviewDetailsRequest: function (event) {
                event.preventDefault();
                self.func.clearValidationMessage();

                if (!$(self.elements.checkbox.checkBox1).is(':checked')) {
                    $(self.elements.messages.invalidFormMessage).show();
                    $(self.css.checkBoxGroup).addClass(self.css.invalidCheckboxError);
                    return;
                }

                $.post(self.urls.cacheReviewPageDetails)
                    .done(function () {
                        window.location.href = self.urls.importantInformation;
                    })
                    .fail(function () {
                        window.location.href = self.urls.errorPageUrl;
                    });
            },
            cancelReviewDetailsRequest: function (event) {
                event.preventDefault();
                // AJAX call to reset the session.
                $.post(self.urls.resetSession)
                    .done(function () {
                        window.location.href = self.urls.manageMembers;
                    })
                    .fail(function () {
                        window.location.href = self.urls.errorPageUrl;
                    });
            },
            clearValidationMessage: function () {
                $(self.elements.messages.invalidFormMessage).hide();
                $(self.css.checkBoxGroup).removeClass(self.css.invalidCheckboxError);
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('reviewDetails' === $('#review-details-form').data('feature')) {
        window.ReviewDetails.Init();
    }
});
